import { z } from "zod";

// NOTE (Ben, 2026-06-21): Lives in its own leaf module (not workspace.ts) so user.ts and auth.ts can
// import it without forming a user → workspace → project → user cycle.
export const workspaceDefaultProjectTypeSchema = z
  .enum(["agent", "shopify_theme_builder"])
  .describe("WorkspaceDefaultProjectType");
